import React from "react";
import { IoBagHandleOutline } from "react-icons/io5";

const ShopCardList = () => {
  const products = [
    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },
    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },
    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },

    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },
    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },
    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },
    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },
    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },
    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },
  ];
  return (
    <div>
      <div className="p-6 max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-6 flex-wrap gap-3">
          <div className="flex gap-3">
            <select className="border px-4 py-2 rounded-full">
              <option>Category</option>
              <option>Category1</option>
              <option>Category2</option>
              <option>Category3</option>
            </select>
            <select className="border px-4 py-2 rounded-full">
              <option>Offers</option>
              <option>Offers</option>
              <option>Offers2</option>
            </select>
          </div>
          <div className="flex gap-3">
            <input
              type="text"
              placeholder="Search products"
              className="border px-4 py-2 rounded-full "
            />
            <select className="border px-4 py-2 rounded-full">
              <option>Sort by</option>
              <option>Today</option>
              <option>Weekly</option>
              <option>Monthy</option>
            </select>{" "}
          </div>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {products.map((product, index) => (
            <ProductCard product={product} key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShopCardList;

function ProductCard({ product }) {
  return (
    <div className=" p-2">
      <div className="relative bg-[#FAFAFA]">
        <div className="w-full h-[170px] object-contain">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-contain"
          />
        </div>

        {product.offer && (
          <span className="absolute top-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded">
            {product.offer}
          </span>
        )}
      </div>

      <p className="mt-4 text-sm text-gray-600 uppercase">{product.name}</p>

      <div className="flex flex-row  justify-between ">
        <div className="flex flex-col">
          <span className="line-through text-gray-400 text-sm">
            ${product.originalPrice}
          </span>
          <span className="text-black font-semibold">
            ${product.discountPrice}
          </span>
        </div>
        <button className="mt-3 flex shrink-0 whitespace-nowrap py-2 px-3 text-sm md:text-[16px] gap-2 md:gap-4 items-center  bg-gray-900 text-white  rounded-full  ">
          <IoBagHandleOutline className="text-lg" />
          Add to Cart
        </button>
      </div>
    </div>
  );
}
